import { enumCodec } from "./useUrlState";

// Single source of truth for the top-level modal open-state.
//
// Analytics and Settings are the two URL-addressable modals. Modeling them as
// one enum param — rather than two independent `?analytics=1` / `?settings=1`
// booleans — makes "both open at once" *unrepresentable*: the param holds
// exactly one value, so the mutual-exclusion invariant holds structurally
// instead of via coordination effects. "none" is the closed state and
// serializes to the absence of the param, keeping URLs clean.
//
// The stop-timer picker is deliberately NOT here: it's transient and carries an
// `entryToSave` payload, so it stays local component state and shouldn't be
// deep-linkable. It's coordinated against this param in TimeTracker instead.

export const MODAL_VIEWS = ["analytics", "settings"] as const;
export type ModalView = (typeof MODAL_VIEWS)[number];
export type ModalParam = ModalView | "none";

// Values derived from MODAL_VIEWS (not a hand-written list) so adding a view to
// the union can't silently drift from what the codec accepts.
export const modalCodec = enumCodec<ModalParam>(["none", ...MODAL_VIEWS], "none");
